module.exports = __webpack_public_path__ + "img/star_1.da61df91.png";